// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = require('../internals/add-to-unscopables');

addToUnscopables('flat');



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/modules/es.array.unscopables.flat.js
// module id = 1351
// module chunks = 1